import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Unauthorized = () => {
  const navigate = useNavigate();
  const [counter, setCounter] = useState(5); // Esperar 5 segundos

  useEffect(() => {
    // Guardar el token antes de limpiar el local storage
    const token = localStorage.getItem('accessToken');

    // Eliminar todos los elementos del localStorage excepto el token
    localStorage.clear(); 
    if (token) {
      localStorage.setItem('accessToken', token); 
    }
    // Reducir el contador cada segundo
    const interval = setInterval(() => {
      setCounter((prevCounter) => prevCounter - 1);
    }, 1000);

    // Redirigir al login cuando el contador llegue a 0
    if (counter === 0) {
      navigate('/', { replace: true });
    }

    // Limpiar el intervalo al desmontar el componente
    return () => clearInterval(interval);
  }, [counter, navigate]);

  return (
    <div className="flex items-center justify-center h-screen bg-red-100 text-red-700 p-4">
      <div className="text-center max-w-md mx-auto">
        <h1 className="text-2xl md:text-4xl font-bold">Su sesión ha terminado</h1>
        <p className="mt-4 text-lg md:text-xl">
          Serás redirigido al inicio de sesión en {counter} segundo{counter !== 1 ? 's' : ''}...
        </p>
      </div>
    </div>
  );
};

export default Unauthorized;